import { get } from 'lodash';

export const operatorMap = {
  eq: 'equals',
  not_eq: 'not equals',
  regex: 'match',
  not_regex: 'not match',
  contains: 'contains',
  not_contains: 'not contains'
} as const;

export enum DataSource {
  video = 'video',
  app = 'app',
  ads = 'ads',
}

export const dataSourceMap = {
  [DataSource.video]: 'Video/Ads',
  [DataSource.app]: 'ECO',
} as const;

export type Operator = keyof typeof operatorMap;

export const isAdmin = (role: string) => role === 'Admin';

export const isInvalidXMLString = (text?: string) => {
  if (!text) return false;
  let match = false;
  // Regex for all not supported characters, currently we are skipping the discouraged charaters.
  // eslint-disable-next-line no-control-regex
  const regex = new RegExp(/((?:[\0-\x08\x0B\f\x0E-\x1F\uFFFD\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/g);
  match = regex.test(text);
  return match;
};

const ALL_CATEGORY = 'ALL';
export const generateAllCategory = () => ({
  category: ALL_CATEGORY,
  subCategory: ''
});

export const isAllCategory = (category: string) => category === ALL_CATEGORY;

export const parseRawCategory = (categoryStr: string) => {
  // Subcategory might have more than 1 slash.
  // So here is to split the category and subcategory based on the first slash
  const [main, ...rest] = String(categoryStr || '').split('/');
  return {
    category: main || '',
    subcategory: rest.join('/') || '',
  };
};


export const gerResponseErrorMessage = (e: Error) => get(e, 'response.data.error', '') || get(e, 'response.data.message', '');
